import React from 'react'
import NavBar from './NavBar';

class Contact extends React.Component {
    render() {
      return (
      <>
<NavBar />
<div class="Contact">
<h2>Contact</h2>

<p>For sales or general enquiries please contact <a href="mailto:sales@ajgsoftware.com" className="heroEmail">
        sales@ajgsoftware.com
      </a>
</p>



</div>   
      </>
      )
    }
  }

  export default Contact;

